export default "__VITE_ASSET__zvY6a7hJ__"